import { render, staticRenderFns } from "./LawPage.vue?vue&type=template&id=5979a7be&scoped=true&"
import script from "./LawPage.vue?vue&type=script&lang=js&"
export * from "./LawPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5979a7be",
  null
  
)

export default component.exports